window.updateAddressText = () => {
    const textarea = document.getElementById('delivery-address');
    textarea.value = ""
}
updateAddressText();
document.addEventListener('DOMContentLoaded', updateAddressText);

window.inputFieldUpdate = (target) => {
    const parentElement = target.parentElement;
    const errorMessage = parentElement.querySelector('.recipientDetailErrorMessage');

    if (!errorMessage.classList.contains('hidden')) {
        errorMessage.classList.add('hidden')
    }
}

window.toggleRecipientDetails = () => {
    const checkbox = document.getElementById('deliver-physical-card');
    const recipientDetails = document.getElementsByClassName('recipientDetails');

    for (let i = 0; i < recipientDetails.length; i++) {
        const element = recipientDetails[i];
        const inputElement = element.querySelector('.recipientDetailInputField');
        const errorMessage = element.querySelector('.recipientDetailErrorMessage');

        if (checkbox.checked) {
            element.classList.remove('hidden');
        } else {
            element.classList.add('hidden');
            errorMessage.classList.add('hidden');
            inputElement.value = ""
        }
    }
}

window.handleSubmit = () => {
    const checkbox = document.getElementById('deliver-physical-card');

    if (checkbox.checked) {
        const recipientName = document.getElementById('recipient-name').value.trim();
        const nameErrorMessage = document.querySelector('.nameErrorMessage');
        if (recipientName.length < 3) {
            nameErrorMessage.classList.remove('hidden')
            return false;
        }

        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        const recipientPhone = document.getElementById('recipient-phone').value.trim();
        const phoneErrorMessage = document.querySelector('.phoneErrorMessage');
        try {
            const phoneNumber = phoneUtil.parseAndKeepRawInput(recipientPhone, 'IN');

            if (phoneUtil.isValidNumber(phoneNumber) == false) {
                phoneErrorMessage.classList.remove('hidden')
                return false;
            }
        } catch (error) {
            phoneErrorMessage.classList.remove('hidden')
            return false;
        }

        const textarea = document.getElementById('delivery-address');
        const address = textarea.value.replace(/[^a-zA-Z0-9\s,.-]/g, '').trim().split(' ')
        const addressErrorMessage = document.querySelector('.addressErrorMessage');

        if (address.length < 5) {
            addressErrorMessage.classList.remove('hidden')
            return false
        }
    }

    return true

}

window.changeGiftCardPrice = (price, id) => {
    const giftCardPrice = document.querySelector('.giftCardPrice');
    giftCardPrice.innerHTML = price;
    const variantId = document.getElementById('variantId')
    variantId.value = id;
}